
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MonthColumnTabbed.html?raw';
import _TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import "../../../moreCore/UI/Tabbing/_TabEnabledMixin";
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import MonthColumnPlanManager from '../MonthColumnPlanManager/MonthColumnPlanManager';

class MonthColumnTabbed extends compose(_WidgetBaseSP, _TabEnabledMixin) {
    templateString: any = template;

    mainContentContainer: HTMLDivElement;

    mainWidget: MdsLax<InstanceType<typeof MonthColumnPlanManager>>;

    private async initLoadDependency(type: 'css' | 'js', targetLink: string) {
        //ladded alle scripts fuer den sceditor, siehe initDependencys()
        switch (type) {
            case "css":
                return new Promise((resolve, reject) => {
                    let newCssElem = document.createElement("link");
                    newCssElem.setAttribute("rel", "stylesheet");
                    newCssElem.href = targetLink;
                    newCssElem.onload = () => resolve(true);
                    newCssElem.onerror = () => reject(false);
                    document.head.appendChild(newCssElem);
                });
                break;
            case "js":
                return new Promise((resolve, reject) => {
                    let newCssElem = document.createElement("script");
                    newCssElem.setAttribute("rel", "stylesheet");
                    newCssElem.src = targetLink;
                    newCssElem.onload = () => resolve(true);
                    newCssElem.onerror = (e) => reject(e);
                    document.head.appendChild(newCssElem);
                });
                break;
        }
    }

    private async init() {
        this.StandbyStart();
        await this.initLoadDependency("css", window.appRoot + "Typescript/WidgetCollection/MonthColumnPlan_TS/css/style.css");
        this.StandbyStop();
        this.mainWidget = new MonthColumnPlanManager();
        this.mainWidget.placeAt(this.mainContentContainer);
    }

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string): void {
        this.init();
    }

    postCreate() {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(MonthColumnTabbed);
